import React from "react";
import { Sparkles } from "lucide-react";
import { Button } from "ui/Button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "ui/Dialog";
import { getStoryUiStrings, resolveStoryLocale } from "i18n/storyUi";

interface ConfirmAwardDialogProps {
  open: boolean;
  targetLabel: string;
  isSubmitting?: boolean;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
}

const ConfirmAwardDialog: React.FC<ConfirmAwardDialogProps> = ({
  open,
  targetLabel,
  isSubmitting = false,
  onConfirm,
  onOpenChange,
}) => {
  const ui = getStoryUiStrings(resolveStoryLocale());
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="inline-flex items-center gap-2">
            <Sparkles className="size-5 text-amber-500" aria-hidden />
            {ui.awardConfirmGiveTitle}
          </DialogTitle>
          <DialogDescription>
            {ui.awardConfirmGiveBody.replace("{target}", targetLabel)}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="ghost" onClick={() => onOpenChange(false)} disabled={isSubmitting}>
            {ui.awardConfirmGiveCancel}
          </Button>
          <Button type="button" onClick={onConfirm} disabled={isSubmitting} aria-busy={isSubmitting}>
            {ui.awardConfirmGiveConfirm}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmAwardDialog;
